/**
 * @module Experince/Search-Results
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

export class Category {
  /**
   * @TODO: Probaly part of pagination, need to verify for future user stories
   * Index for pagination
   */
  public index: string;

  /**
   * Category title (Brand, Color, etc)
   */
  private categoryTitle: string;

  /**
   * Selected label within that category
   */
  public selectedLabels: string[];

  constructor(categoryTitle: string) {
    this.categoryTitle = categoryTitle;
    this.selectedLabels = [];
  }

  /**
   * Function adds new label to category
   * @param addLabel New label to add to category
   */
  public addLabel(addLabel: string): void {
    this.selectedLabels.push(addLabel);
  }

  /**
   * Function checks if facet is selected in queryModel
   * @param facet Label/facet
   */
  public isFacetSelected(facet: string): boolean {
    return this.selectedLabels.indexOf(facet) >= 0;
  }

  /**
   * Funciton to remove label from category
   * @param removeLabel Returns true if all the selected labels have been removed
   * This would mean that the parent model would remove category
   */
  public removeLabel(removeLabel: string): boolean {
    const indexOfRemoveLabel = this.selectedLabels.indexOf(removeLabel);
    if (indexOfRemoveLabel > 0) {
      this.selectedLabels.splice(indexOfRemoveLabel, 1);
    }
    // Return true or false if there are any selected labels within category
    return this.selectedLabels.length > 0;
  }

  /**
   * Retrive the Labels appended together for querying
   */
  public getLabelQuery(): string {
    let labelQuery = '';
    for (let index = 1; index <= this.selectedLabels.length; index++) {
      labelQuery += this.selectedLabels[index - 1];
      labelQuery += index !== this.selectedLabels.length ? '|' : '';
    }
    return labelQuery;
  }
}
